module.exports = __webpack_public_path__ + "static/media/introducao.65004e24.png";